import React from "react";

interface HeaderProps {
  onToggleMobileMenu: () => void;
  onToggleSidebar: () => void;
  isSidebarCollapsed: boolean;
  isMobile: boolean;
}

const Header: React.FC<HeaderProps> = ({ 
  onToggleMobileMenu, 
  onToggleSidebar, 
  isSidebarCollapsed, 
  isMobile 
}) => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const handleLogout = () => {
    localStorage.removeItem("user");
    window.location.href = "/login";
  };

  return (
    <header style={{
      backgroundColor: '#0C2342',
      color: 'white',
      padding: '0.75rem 1rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      minHeight: '60px',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1001
    }}>
      {/* Logo y Menu Toggle */}
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {/* Botón de menú para móvil o sidebar colapsado */}
        {(isMobile || isSidebarCollapsed) && (
          <button
            onClick={isMobile ? onToggleMobileMenu : onToggleSidebar}
            style={{
              background: 'rgba(255,255,255,0.1)',
              border: '1px solid rgba(255,255,255,0.2)',
              color: 'white',
              padding: '0.75rem',
              borderRadius: '0.5rem',
              cursor: 'pointer',
              marginRight: '1rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s ease',
              fontSize: '0.875rem',
              fontWeight: '500'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.2)';
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            <svg
              width="24"
              height="24"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              style={{ marginRight: '0.5rem' }}
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
            {isSidebarCollapsed && !isMobile && 'Menú'}
          </button>
        )}
        
        <img
          src="https://bajabox.com.mx/wp-content/uploads/2024/12/fon-blan.webp"
          alt="BajaBox Logo"
          style={{ height: '40px', width: 'auto' }}
        />
        <span style={{ marginLeft: '1rem', fontWeight: 'bold' }}>
          BBX Documentation
        </span>
      </div>

      {/* Usuario y logout */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        {user.name && (
          <span style={{ fontSize: '0.875rem', color: '#e5e7eb' }}>
            {user.name}
          </span>
        )}
        <button
          onClick={handleLogout}
          style={{
            backgroundColor: '#dc2626',
            color: 'white',
            border: 'none',
            padding: '0.5rem 1rem',
            borderRadius: '0.375rem',
            cursor: 'pointer',
            fontSize: '0.875rem'
          }}
        >
          Cerrar Sesión
        </button>
      </div>
    </header>
  );
};

export default Header;